export default "__VITE_ASSET__GgJKtHHg__"